import { z } from 'zod'

export const SearchParamsDetailsSchema = z.object({
  historyPage: z.number().int().nonnegative().optional(),
  historySize: z.number().int().nonnegative().optional(),
  publicationsPage: z.number().int().nonnegative().optional(),
  publicationsSize: z.number().int().nonnegative().optional(),
  publicationsStatus: z.string().default('needs_review')
})
